$('variant-selects.no-js-hidden .product-form__input.product-form__input--dropdown .select select').change(function(){
  $(".CorePopopopoverContent").hide();
var valu_text=$(this).val();
const substr = 'Select';
var real_text_slct=valu_text.includes(substr);

if(real_text_slct==true){
$("span.real_add_to_cart").hide();
$(".select_add_to_cart").show();
}
else{
$("span.real_add_to_cart").show();
$(".select_add_to_cart").hide();
}
  setTimeout(function () {

$('variant-selects.no-js-hidden .product-form__input.product-form__input--dropdown .select select option').each(function(){
var $text = $(this);
$text.html( $text.html().replace("- Unavailable", "") );
})
                           }, 0);
})
$(".select_add_to_cart").click(function(){
$(".CorePopopopoverContent").show();
})
